module.exports = __webpack_public_path__ + "static/scale-model-of-houston-is-inspired-mural-in-houston-texas-c0c32b1533b5cd480bd13bc94727dc48.png";